"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantsSubPackage = void 0;
const constants_1 = require("../logic/constants");
class ConstantsSubPackage {
    constructor(signer) {
        (() => __awaiter(this, void 0, void 0, function* () {
            const chainID = yield (0, constants_1._extractChainID)(signer);
            const values = (0, constants_1._getChainSpecificConstants)(chainID);
            this.factoryAddresses = values === null || values === void 0 ? void 0 : values.factoryAddresses;
            this.customErrors = values === null || values === void 0 ? void 0 : values.customErrors;
            return this;
        }))();
    }
}
exports.ConstantsSubPackage = ConstantsSubPackage;
